import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    support: 'xs:container mt-12 mb-25 max-sm:mb-15 lg:max-w-[1312px]',
    faq: 'container max-w-[1312px]'
  }
});
